import Vue from 'vue';
import VueUnleash from 'vue-unleash';
import Vuex from 'vuex';
import Inspection from './modules/inspection';
import Inspectors from './modules/inspectors';
import Documents from './modules/documents';
import User from './modules/user';
import Customer from './modules/customer';
import Http from './modules/http';
import Receipt from './modules/receipt';
import Invoice from './modules/invoice';
import Folders from './modules/folders';
import Payment from './modules/payment';
import HgClassic from './modules/hgClassic';
import HomebuyerOffers from './modules/homebuyer-offers';
import Company from './modules/company';
import Offers from './modules/offers';
import Leads from './modules/leads';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loaded: true,
    loading: false,
  },
  actions: {
    setLoaded(context, isLoaded) {
      context.commit('setLoaded', isLoaded);
    },
  },
  mutations: {
    loaded(state) {
      state.loaded = false;
    },
    setLoaded(state, isLoaded) {
      state.loaded = isLoaded;
    },
  },
  modules: {
    Inspection,
    Inspectors,
    Documents,
    User,
    Customer,
    Http,
    Receipt,
    Invoice,
    Folders,
    Payment,
    HgClassic,
    HomebuyerOffers,
    Company,
    Offers,
    Leads,
  },
});

Vue.use(VueUnleash, {
  appName: 'home-buyer-dashboard',
  host: process.env.VUE_APP_UNLEASH_URL,
  store,
});

export default store;
